(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-bestsellers"]) return;
  try {
    
(function () {
  /* Kayan yazi: OC gibi ~40 px/sn; hiz dile gore degisen grup genisliginden hesaplanir */
  function sizeMarquee(root) {
    var track = root.querySelector('.kt-bs__mq-track');
    var group = track && track.querySelector('.kt-bs__mq-group');
    if (!group || !group.offsetWidth) return;
    track.style.setProperty('--kt-mq-dur', (group.offsetWidth / 40).toFixed(1) + 's');
  }

  /* Teklif seridi telefonda tek satir kalsin diye yazi kuculur; masaustunde hic dokunulmaz (Kural 20) */
  function fitOffer(root) {
    var el = root.querySelector('.kt-bs__offer');
    if (!el) return;
    el.style.fontSize = '';
    el.classList.remove('is-wrapped');
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var size = parseFloat(window.getComputedStyle(el).fontSize);
    while (el.scrollWidth > el.clientWidth && size > 16) {
      size -= 1;
      el.style.fontSize = size + 'px';
    }
    if (el.scrollWidth > el.clientWidth) el.classList.add('is-wrapped');
  }

  /* Why Bamboo: OC gibi sola surekli akar (~30 px/sn), masaustunde surukle, telefonda dogal kaydirma */
  function initWhy(root) {
    var why = root.querySelector('.kt-bs__why');
    var track = why && why.querySelector('.kt-bs__why-track');
    var firstSet = track && track.querySelector('.kt-bs__why-set');
    if (!firstSet || track.dataset.ktInit) return;
    track.dataset.ktInit = '1';
    var speed = (parseFloat(why.dataset.ktSpeed) || 30) / 60;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dragging = false, hovering = false, visible = true, lastX = 0, pos = 0;

    function setWidth() { return firstSet.offsetWidth; }
    function normalize() {
      var w = setWidth();
      if (w <= 0) return;
      if (track.scrollLeft < w * 0.5) track.scrollLeft += w;
      else if (track.scrollLeft >= w * 1.5) track.scrollLeft -= w;
      pos = track.scrollLeft;
    }
    function tick() {
      if (!dragging && !hovering && visible && !reduce) {
        pos += speed;
        track.scrollLeft = pos;
      }
      normalize();
      requestAnimationFrame(tick);
    }
    function start() {
      if (setWidth() <= 0) { requestAnimationFrame(start); return; }
      track.scrollLeft = setWidth();
      pos = track.scrollLeft;
      requestAnimationFrame(tick);
    }

    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (e.pointerType === 'mouse') {
        lastX = e.clientX;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add('is-dragging');
        e.preventDefault();
      }
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerType !== 'mouse') return;
      track.scrollLeft -= e.clientX - lastX;
      lastX = e.clientX;
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      track.addEventListener(ev, function () {
        dragging = false;
        track.classList.remove('is-dragging');
      });
    });
    track.addEventListener('touchend', function () { dragging = false; });
    track.addEventListener('mouseenter', function () { hovering = true; });
    track.addEventListener('mouseleave', function () { hovering = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(track);
    }

    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }

  function initAll() {
    document.querySelectorAll('.kt-bs').forEach(function (root) {
      fitOffer(root);
      sizeMarquee(root);
      initWhy(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  /* web fontu yuklenince genislikler degisir, olculer tekrar alinir */
  window.addEventListener('load', function () {
    document.querySelectorAll('.kt-bs').forEach(function (root) {
      fitOffer(root);
      sizeMarquee(root);
    });
  });
  var ktResize;
  window.addEventListener('resize', function () {
    clearTimeout(ktResize);
    ktResize = setTimeout(function () {
      document.querySelectorAll('.kt-bs').forEach(fitOffer);
    }, 150);
  });
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-pdp-bamboo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('.oc-bamboo__track');
    if (!track || track.dataset.ocInit) return;
    track.dataset.ocInit = '1';
    var firstSet = track.querySelector('.oc-bamboo__set');
    if (!firstSet) return;
    var speed = (parseFloat(root.dataset.speed) || 30) / 60; // px per frame at 60fps
    var dragging = false;
    var hovering = false;
    var lastX = 0;

    function setWidth() { return firstSet.scrollWidth; }

    function normalize() {
      var w = setWidth();
      if (w <= 0) return;
      if (track.scrollLeft < w * 0.5) track.scrollLeft += w;
      else if (track.scrollLeft >= w * 1.5) track.scrollLeft -= w;
    }

    function start() {
      var w = setWidth();
      if (w <= 0) { requestAnimationFrame(start); return; }
      track.scrollLeft = w;
      requestAnimationFrame(tick);
    }

    function tick() {
      if (!dragging && !hovering) track.scrollLeft -= speed; // content slides to the right
      normalize();
      requestAnimationFrame(tick);
    }

    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (e.pointerType === 'mouse') {
        lastX = e.clientX;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add('is-dragging');
        e.preventDefault();
      }
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerType !== 'mouse') return;
      track.scrollLeft -= e.clientX - lastX;
      lastX = e.clientX;
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      track.addEventListener(ev, function () {
        dragging = false;
        track.classList.remove('is-dragging');
      });
    });
    track.addEventListener('touchend', function () { dragging = false; });
    track.addEventListener('mouseenter', function () { hovering = true; });
    track.addEventListener('mouseleave', function () { hovering = false; });

    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }

  function initAll() {
    document.querySelectorAll('.oc-bamboo').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-press-logos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('.oc-press__track');
    if (!track || track.dataset.ocInit) return;
    track.dataset.ocInit = '1';
    var firstSet = track.querySelector('.oc-press__set');
    if (!firstSet) return;
    var speed = (parseFloat(root.dataset.speed) || 60) / 60; // px per frame at 60fps
    var dragging = false;
    var hovering = false;
    var lastX = 0;

    function setWidth() { return firstSet.scrollWidth; }

    function normalize() {
      var w = setWidth();
      if (w <= 0) return;
      if (track.scrollLeft < w * 0.5) track.scrollLeft += w;
      else if (track.scrollLeft >= w * 1.5) track.scrollLeft -= w;
    }

    function start() {
      var w = setWidth();
      if (w <= 0) { requestAnimationFrame(start); return; }
      track.scrollLeft = w;
      requestAnimationFrame(tick);
    }

    function tick() {
      if (!dragging && !hovering) track.scrollLeft += speed;
      normalize();
      requestAnimationFrame(tick);
    }

    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (e.pointerType === 'mouse') {
        lastX = e.clientX;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.classList.add('is-dragging');
        e.preventDefault();
      }
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerType !== 'mouse') return;
      track.scrollLeft -= e.clientX - lastX;
      lastX = e.clientX;
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      track.addEventListener(ev, function () {
        dragging = false;
        track.classList.remove('is-dragging');
      });
    });
    track.addEventListener('touchend', function () { dragging = false; });
    track.addEventListener('mouseenter', function () { hovering = true; });
    track.addEventListener('mouseleave', function () { hovering = false; });

    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }

  function initAll() {
    document.querySelectorAll('.oc-press').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
